import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CmsParagraphComponent } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';

@Component({
  selector: 'app-footer-terms-of-use',
  templateUrl: './footer-terms-of-use.component.html',
  styleUrl: './footer-terms-of-use.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class FooterTermsOfUseComponent implements OnInit {

  public componentData: CmsParagraphComponent;

  constructor(
    public component: CmsComponentData<CmsParagraphComponent>
  ) { }

  ngOnInit(): void {
    this.component.data$.subscribe((data) => {
      this.componentData = data;
    });
  }
}
